import { ReturnToAppPrompt } from '@/components/auth/return-to-app-prompt';
import { ThemedText } from '@/components/themed-text';
import { useAuthStore } from '@/store/authStore';
import React, { useEffect } from 'react';
import { Platform } from 'react-native';

export default function ReturnToAppScreen() {
  const fetchProfile = useAuthStore((s) => s.fetchProfile);

  useEffect(() => {
    if (Platform.OS === 'web') {
      void fetchProfile();
    }
  }, [fetchProfile]);

  return (
    <ReturnToAppPrompt
      title="Conta criada!"
      description={
        <>
          Seu cadastro foi concluído com sucesso.{' '}
          <ThemedText className="font-bold text-primary">Volte ao aplicativo</ThemedText> para
          continuar.
        </>
      }
      testId="return-to-app-open"
      continueOnWebHref="/(tabs)/(client)/hoje"
    />
  );
}
